import {AfterViewInit, Component} from '@angular/core';
import {ComponentCleaner} from '../../../component-cleaner';
import {PermissionWrapper} from '../../../directives/if-permission.directive';
import {CustomerGroup} from '../../../models';
import {MatDialog} from '@angular/material/dialog';
import {CustomerGroupService} from '../../customer-group/customer-group.service';
import {filter} from 'rxjs/operators';
import {GuacServerEditComponent} from './guac-server-edit/guac-server-edit.component';
import {CrudOperationWrapper} from '../../../helpers/kluh';

@Component({
    selector: 'app-gateway-server',
    templateUrl: './guac-server.component.html',
    styleUrls: ['./guac-server.component.scss']
})
export class GuacServerComponent extends ComponentCleaner implements AfterViewInit {
    canEditList: PermissionWrapper[];
    customerGroup: CustomerGroup;
    reloadChild = true;

    constructor(
        private dialogRef: MatDialog,
        private customerGroupService: CustomerGroupService,
        private dialog: MatDialog,
    ) {
        super();
        this.canEditList =
            [
                {type: 'GuacServer', permission: 'CREATE', parentType: 'CustomerGroup', parent: this.customerGroupService.customerGroup}
            ];

    }

    ngAfterViewInit(): void {
        this.customerGroupService.get().subscribe(customerGroup => {
            if (customerGroup) {
                this.customerGroup = customerGroup;
            }
        });
    }

    create(): void {
        const dialogRef = this.dialog.open(GuacServerEditComponent, {
            disableClose: true,
            panelClass: 'generic-edit-dialog-x-large',
            data: {
                guacServer: null,
                customerGroupId: this.customerGroup.id,
            }
        });
        this.addSubscription(dialogRef.afterClosed().pipe(filter((x) => !!(x))).subscribe((result: CrudOperationWrapper) => {
            if (result.operation !== 'CANCEL') {
                this.reloadChildComponent();
            }
            this.dialogRef.closeAll();
        }));
    }

    reloadChildComponent(): void {
        this.reloadChild = false;
        setTimeout(() => this.reloadChild = true);
    }
}
